import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "content"]
  static values = { activeTab: String }

  connect() {
    // Use activeTabValue if provided, otherwise try to detect default from available tabs
    let defaultTab = this.activeTabValue
    
    if (!defaultTab && this.tabTargets.length > 0) {
      // Use the first tab as default if no activeTabValue is set
      defaultTab = this.tabTargets[0].dataset.tab
    }
    
    this.updateTabStates(defaultTab)
  }

  switchTab(event) {
    event.preventDefault()
    const clickedTab = event.currentTarget
    const tabId = clickedTab.dataset.tab
    
    // Update visual state and content
    this.updateTabStates(tabId)
  }

  updateTabStates(activeTabId) {
    // Update tab button styles
    this.tabTargets.forEach(tab => {
      const tabId = tab.dataset.tab
      
      if (tabId === activeTabId) {
        // Active tab styles
        tab.classList.remove("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300", "dark:text-gray-400", "dark:hover:text-gray-300")
        tab.classList.add("border-primary-500", "text-primary-600", "dark:text-primary-400", "dark:border-primary-400")
      } else {
        // Inactive tab styles
        tab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300", "dark:text-gray-400", "dark:hover:text-gray-300")
        tab.classList.remove("border-primary-500", "text-primary-600", "dark:text-primary-400", "dark:border-primary-400")
      }
    })

    // Show/hide content areas
    this.contentTargets.forEach(content => {
      const contentTabId = content.dataset.tab
      
      if (contentTabId === activeTabId) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
